/**
 * Loader - Composant d'affichage d'un indicateur de chargement.
 *
 * @param {Object} props
 * @param {string} [props.label] - Texte affiché sous le loader
 * @param {string} [props.className] - Classes CSS additionnelles
 * @returns {JSX.Element}
 *
 * @example
 * <Loader label="Chargement..." />
 */
import React from 'react';

export default function Loader({ className = '', label = 'Chargement...' }) {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`} aria-label={label} role="status">
      <span className="relative flex h-8 w-8 mb-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent/30 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-8 w-8 bg-gradient-to-br from-accent/60 to-blue-200"></span>
      </span>
      <span className="text-xs text-blue-gray-400 font-medium">{label}</span>
    </div>
  );
} 